import React from 'react'
import { createRoot } from 'react-dom/client'

import WidgetApp from 'WidgetApp'

import QuinstreetWidget from './QuinstreetWidget'

const root = createRoot(document.getElementById('root'))

root.render(
  <WidgetApp>
    <QuinstreetWidget />
  </WidgetApp>,
)
